import React, { useState, useEffect, useRef } from 'react';
import ItemContent from './item-content';
import Seo from './seo';
import axios from '../axios';

interface Postagem {
    id: number,
    titulo: string,
    descricao: string,
    tipo: string,
    link: string,
    linkDescricao: string,
    tags: [],
    data: string
}

const Apis = () => {

    const [postagens, setPostagens] = useState<Postagem[]>([]);
    const [disabled, setDisabled] = useState(true);
    const [offset, setOffset] = useState(0);
    const limit = 50;
    const [btnText, setBtnText] = useState('Sem mais postagens');
    const [searchText, setSearchText] = useState('');
    const searchRef = useRef<HTMLInputElement>(null);

    const filteredPostagens = postagens.filter(p => {
        const term = searchText.toLowerCase().trim();
        if (!term) return true;
        return p.titulo.toLowerCase().includes(term) ||
            p.descricao.toLowerCase().includes(term) ||
            p.tags.some((tag: string) => tag.toLowerCase().includes(term));
    });

    useEffect(() => {
        axios.get<Postagem[]>('apis')
            .then(response => {
                setPostagens(response.data);
            })
    }, []);

    useEffect(() => setOffset(postagens.length), [postagens]);

    useEffect(() => {
        if (postagens.length % limit === 0) {
            if (postagens.length >= limit) {
                setDisabled(false);
                setBtnText('Carregar mais postagens')
            }
        } else {
            setDisabled(true);
            setBtnText('Sem mais postagens');
        }
    }, [postagens]);

    const readMore = () => {
        axios.get<Postagem[]>(`api?offset=${offset}`)
            .then(response => {
                const newPosts: Postagem[] = response.data;
                setPostagens([...postagens, ...newPosts]);
            })
    }

    return (
        <div className="home">
            <Seo
                title="APIs"
                description="APIs publicadas por Cesar Castro."
                path="/apis"
            />
            <h1 className="visually-hidden">APIs</h1>
            <div className="terminal-prompt" onClick={() => searchRef.current?.focus()}>
                <span className="terminal-prompt-line">
                    <span className="prompt-user">user</span>
                    <span className="prompt-at">@</span>
                    <span className="prompt-host">cesarcastro</span>
                    <span className="prompt-sep">:</span>
                    <span className="prompt-path">~/apis</span>
                    <span className="prompt-dollar">$</span>
                    <span className="prompt-cmd">curl -s /apis</span>
                    <span className={`query-wrapper${searchText ? ' has-value' : ''}`}>
                        <span className="prompt-query-prefix">?query=</span>
                        <input
                            ref={searchRef}
                            className="filter-grep"
                            type="text"
                            value={searchText}
                            onChange={e => setSearchText(e.target.value)}
                            placeholder="search"
                            aria-label="Filter APIs"
                            spellCheck={false}
                            autoComplete="off"
                        />
                    </span>
                    <span className="prompt-cmd"> | jq '.'</span>
                    <span className="cursor"></span>
                    <span className="prompt-hint" aria-hidden="true"># click here to search</span>
                </span>
            </div>
            <div className="home-content">
                {postagens.length === 0 ? (<div className="null"><h2>NULL</h2></div>) :
                filteredPostagens.length === 0 ? (<div className="null"><h2>grep: no match for "{searchText}"</h2></div>) :
                    filteredPostagens.map((post, idx) => {
                        return (<ItemContent
                            key={idx}
                            id={post.id}
                            title={post.titulo}
                            type={post.tipo}
                            description={post.descricao}
                            link={post.link}
                            linkDescription={post.linkDescricao}
                            tags={post.tags}
                            date={post.data}
                            color={post.tipo === "API" ? "white" : "green"}
                        />)
                    })}
            </div>
            <button type="button" onClick={readMore} className="btn-readmore" disabled={disabled}>{btnText}</button>
        </div>
    );
}

export default Apis;
